module.exports = __webpack_public_path__ + "img/3d-logo-text-240.b85ff556.png";